export default __webpack_public_path__ + "static/media/values-banner.b3f4e0cc.webp";